import { Box } from "@mui/material";
import { Fragment } from "react";

const SampleOriginDistribution = () => {

    const data = [
        {
            title: 'Domestic',
            percentage: '24.6%',
            number: 1101,
            color: '#246898'
        },
        {
            title: 'EU',
            percentage: '6.41%',
            number: 287,
            color: '#00A1C8'
        },
        {
            title: 'Third countries',
            percentage: '64.6%',
            number: 2891,
            color: '#B3CEE7'
        },
        {
            title: 'Unknown',
            percentage: '4.38%',
            number: 196,
            color: '#808080'
        },
    ]


    return (
        <Fragment>
            <Box><p style={{ marginBottom: '.5rem', fontFamily: 'Roboto Condensed, sans-serif' }}>Above legal limit sample origin distribution</p></Box>
            <Box display='flex' flexWrap='wrap' justifyContent={{ xs: 'start', sm: 'start', md: 'space-between' }}>

                {
                    data.map((d, idx) => {
                        return (
                            <Box m={{ xs: 1, sm: 1, md: 0 }} key={idx} sx={{ paddingLeft: '.5rem', borderLeft: `3px ${d.color} solid` }}>
                                <p style={{ margin: 0, fontSize: '14px', fontFamily: 'Roboto Condensed, sans-serif' }}>{d.title}</p>
                                <p style={{ margin: 0, fontSize: '14px', fontFamily: 'Roboto Condensed, sans-serif' }}><b>{d.percentage}</b><span style={{ paddingLeft: '5px', fontSize: '14px' }}>({d.number})</span></p>
                            </Box>
                        );
                    })
                }
            </Box >
        </Fragment>
    );

}

export default SampleOriginDistribution;